import React from 'react';
import { string } from 'prop-types';
import { Box, Center, Image } from '@chakra-ui/react';

import WithAnimation from '@components/Common/WithAnimation';
import Detail from './Detail';

import { BG_COVER, IMG_LOGO_US } from '@/constants/assets';

/**
 * function to render WeddingSectionV3 component
 * @returns {JSX.Element}
 */
function WeddingSection({ lang, ...rest }) {
  return (
    <Box
      padding="42px 32px"
      bgImage={`url(${BG_COVER})`}
      bgSize="cover"
      bgColor="bgPrimary"
      {...rest}
    >
      <Box
        padding="16px"
        bgColor="bgSecondary"
        borderRadius="16px"
        border="2px solid"
        borderColor="mainColorText"
        color="mainColorText"
      >
        <Center>
          <WithAnimation>
            <Image src={IMG_LOGO_US} maxW="200px" marginBottom="24px" />
          </WithAnimation>
        </Center>
        <Detail
          lang={lang}
          items={[
            {
              title: 'HARI PERTAMA',
              date: 'Senin, 1 Agustus 2022',
              dresscodeUrl: 'https://user-images.githubusercontent.com/106049860/181875475-31ccf9ff-5e71-4086-964d-dfc1664e9b3c.jpeg',
              location: 'Poncowati Ballroom, <br /> Patra Hotel & Convention',
              locationRoad: 'Jl. Sisingamangaraja, Wonotingal, Kec. Candisari, Kota Semarang',
              time: '10.00 - 21.00 WIB',
              show: true,
            },
            {
              title: 'HARI KEDUA',
              date: 'Selasa, 2 Agustus 2022',
              dresscodeUrl: 'https://user-images.githubusercontent.com/106049860/181875476-166f7a39-20f4-4b8d-961e-8859797d67ef.jpeg',
              location: 'Poncowati Ballroom,<br /> Patra Hotel & Convention',
              locationRoad: 'Jl. Sisingamangaraja, Wonotingal, Kec. Candisari, Kota Semarang',
              time: '10.00 - 21.00 WIB',
              show: true,
            },
            {
              title: 'HARI KETIGA',
              date: 'Rabu, 3 Agustus 2022',
              dresscodeUrl: 'https://user-images.githubusercontent.com/106049860/181875479-8115af4a-9a84-4f6d-8326-d1f8bf8b610a.jpeg',
              location: 'Poncowati Ballroom, <br /> Patra Hotel & Convention',
              locationRoad: 'Jl. Sisingamangaraja, Wonotingal, Kec. Candisari, Kota Semarang',
              time: '10.00 - 21.00 WIB',
              show: true,
            },
          ]}
        />
      </Box>
    </Box>
  );
}

WeddingSection.propTypes = {
  lang: string.isRequired,
};

export default React.memo(WeddingSection);
